<template>
	<form class="wide section--floating" @submit.prevent="submit">
		<div v-if="!form.isReady()" class="section">
			<loader/>
		</div>
		<div v-else>
			<v-tabs
				id="client-form-tabs"
				ref="tabs"
				v-slot="{goToNext}" :disable-nav="true" :hide-navigation-for-single-tab="false" class="tabs--switch">
				<v-tab
					id="service-details"
					:tab-key="1"
					label="Service Details">
					<fieldset class="fieldset">
						<div>
							<div>
								<legend><span class="beta heavy">Service details</span></legend>
							</div>
							<div>
								<div class="input-group">
									<label><span>Service </span>
										<select v-model="form.data.service" @change="selectService()">
											<option disabled selected value="">—</option>
											<option
												v-for="(service, serviceIndex) in form.options.services"
												:key="serviceIndex"
												:value="service.key" v-html="service.names.singular"/>
										</select>
										<div v-if="form.errors.has('service')" class="error-block">
											<p v-html="form.errors.get('service')"/>
										</div>
									</label>
									<label :class="labelClass(!!selectedService)"><span>Referrer </span>
										<select v-model="form.data.referrer" :disabled="isDisabled(!!selectedService)">
											<option selected value="">None (private work)</option>
											<option
												v-for="(referrer, referrerIndex) in validReferrers"
												:key="referrerIndex"
												:value="referrer.id" v-html="referrer.profile.name"/>
										</select>
									</label>
								</div>
							</div>
						</div>
					</fieldset>
					<fieldset class="fieldset">
						<div>
							<div>
								<legend><span class="beta heavy">Assign case</span></legend>
							</div>
							<div class="input-group">
								<label class="checkbox"><span>Assign this case</span>
									<input v-model="form.data.assign.should_assign" type="checkbox">
								</label>
								<label :class="labelClass(form.data.assign.should_assign)"><span>Team </span>
									<select
										v-model="form.data.assign.team"
										:disabled="isDisabled(form.data.assign.should_assign)"
										name="user">
										<option selected value="">—</option>
										<option
											v-for="(team, teamIndex) in form.options.teams" :key="teamIndex"
											:value="team.id"
											v-html="team.name"/>
									</select>
									<div v-if="form.errors.has('assign.team')" class="error-block">
										<p v-html="form.errors.get('assign.team')"/>
									</div>
								</label>
								<label :class="labelClass(form.data.assign.should_assign)"><span>Colleague </span>
									<select
										v-model="form.data.assign.user"
										:disabled="isDisabled(form.data.assign.should_assign)"
										name="user">
										<option selected value="">—</option>
										<option
											v-for="(colleague, colleagueIndex) in colleagues"
											:key="colleagueIndex"
											:value="colleague.id" v-html="$present('fullName', colleague.profile)"/>
									</select>
									<div v-if="form.errors.has('assign.user')" class="error-block">
										<p v-html="form.errors.get('assign.user')"/>
									</div>
								</label>
							</div>
							<div class="actions">
								<ul>
									<li>
										<process-button
											:processing="form.processing"
											class="button button--primary"
											text="Continue"
											@click.prevent="validate('service_details', goToNext)"/>
									</li>
								</ul>
							</div>
						</div>
					</fieldset>
				</v-tab>
				<template v-if="form.data.service">
					<v-tab
						id="client-details"
						:tab-key="2"
						label="Client Details">
						<fieldset class="fieldset">
							<div>
								<div>
									<legend><span class="beta heavy">Client details</span></legend>
								</div>
								<div class="input-group">
									<div class="input">
										<div class="input-group input-group--wrap">
											<label><span>First name </span>
												<input v-model="form.data.client.profile.name.first" type="text">
											</label>
											<label><span>Middle name <span class="optional">— optional </span></span>
												<input v-model="form.data.client.profile.name.middle" type="text">
											</label>
											<label><span>Last name </span>
												<input v-model="form.data.client.profile.name.last" type="text">
											</label>
										</div>
										<div
											v-if="form.errors.has('client.profile.name')" class="error-block">
											<p v-html="form.errors.first('client.profile.name')"/>
										</div>
									</div>
									<label><span>Email </span>
										<input v-model="form.data.client.email" type="text">
										<div v-if="form.errors.has('client.email')" class="error-block">
											<p v-html="form.errors.get('client.email')"></p>
										</div>
									</label>
									<label><span>Email Confirmation </span>
										<input
											v-model="form.data.client.email_confirmation" onpaste="return false;"
											type="text">
									</label>
									<label><span>Phone </span>
										<input v-model="form.data.client.profile.phone" type="text">
										<div v-if="form.errors.has('client.profile.phone')" class="error-block">
											<p v-html="form.errors.get('client.profile.phone')"></p>
										</div>
									</label>
									<!--								<label><span>Date of birth <span class="optional">— optional </span></span>-->
									<!--									<div v-if="form.errors.get('client.dob')" class="error-block">-->
									<!--										<p v-html="form.errors.get('client.dob')"></p>-->
									<!--									</div>-->
									<!--									&lt;!&ndash;							<v-datepicker v-model="form.data.client.dob"/>&ndash;&gt;-->
									<!--									<v-dobpicker-->
									<!--										v-model="form.data.client.dob"-->
									<!--										date-display-format="DD/MM/YYYY"/>-->
									<!--									<div class="help-block">-->
									<!--										<p>Please enter your date of birth in the following format dd/mm/yyyy.</p>-->
									<!--									</div>-->
									<!--								</label>-->
									<AddressLookup
										v-model="form.data.client.profile.address"
										:errors="form.errors.get('client.profile.address')"
										class="fieldset-section"
										fieldId="client-postcode"
										label="Current address"/>
								</div>
								<div class="actions">
									<ul>
										<li>
											<process-button
												:processing="form.processing"
												class="button button--primary"
												text="Continue"
												@click.prevent="validate('client', goToNext)"/>
										</li>
									</ul>
								</div>
							</div>
						</fieldset>
					</v-tab>
					<v-tab
						v-if="form.data.service === 'conveyancing'"
						id="conveyancing-details"
						:tab-key="3"
						label="Conveyancing Details">
						<fieldset class="fieldset">
							<div>
								<div>
									<legend><span class="beta heavy">Conveyancing details</span></legend>
								</div>
								<ConveyancingFieldsets :form="form"/>
								<div class="actions">
									<ul>
										<li>
											<button
												class="button button--primary"
												@click.prevent="validate('data', goToNext)">Continue
											</button>
										</li>
									</ul>
								</div>
							</div>
						</fieldset>
					</v-tab>
					<v-tab
						id="other-clients"
						:on-show="setAdditionalClientFields"
						:tab-key="4"
						label="Other Clients">
						<div v-if="!additionalClientDetailRequired">
							<p>None required!</p>
						</div>
						<fieldset v-if="numberOfAdditionalSellers" class="fieldset">
							<div>
								<div>
									<legend>
<span
	class="fieldset__label beta"
	v-html="stringer('Please provide contact details for the ?').nGetText('other seller', '# other sellers', numberOfAdditionalSellers).value"/>
									</legend>
								</div>
								<div>
									<fieldset
										v-for="index in numberOfAdditionalSellers" :key="index"
										class="input">
										<legend><span class="beta">{{ $present("ordinal", index + 1) }} Seller</span>
										</legend>
										<div class="input-group">
											<div class="input">
												<div class="input-group input-group--wrap">
													<label class="input"><span>First name </span>
														<input
															v-model="form.data.clients.sale[index - 1].profile.name_first"
															type="text"/>
													</label>
													<label><span>Middle name <span
														class="optional">— optional </span></span>
														<input
															v-model="form.data.clients.sale[index - 1].profile.name_middle"
															type="text">
													</label>
													<label class="input"><span>Last name </span>
														<input
															v-model="form.data.clients.sale[index - 1].profile.name_last"
															type="text"/>
													</label>
												</div>
												<div
													v-if="form.errors.get('clients.sale.*.profile', index - 1)"
													class="error-block">
													<p>The client full name is required</p>
												</div>
											</div>
											<label class="input"><span>Email </span>
												<input
													v-model="form.data.clients.sale[index - 1].email"
													type="text"/>
												<div
													v-if="form.errors.get('clients.sale.*.email', index - 1)"
													class="error-block">
													<p v-html="form.errors.get('clients.sale.*.email', index - 1)"/>
												</div>
											</label>
										</div>
									</fieldset>
								</div>
							</div>
						</fieldset>
						<fieldset v-if="numberOfAdditionalPurchasers" class="fieldset">
							<div>
								<div>
									<legend>
													<span
														class="fieldset__label beta"
														v-html="stringer('Please provide contact details for the ?').nGetText('other purchaser', '# other purchasers', numberOfAdditionalPurchasers).value"/>
									</legend>
								</div>
								<div>
									<fieldset
										v-for="index in numberOfAdditionalPurchasers" :key="index"
										class="input">
										<legend><span class="beta">{{ $present("ordinal", index + 1) }} Purchaser</span>
										</legend>
										<div class="input-group">
											<div class="input">
												<div class="input-group input-group--wrap">
													<label class="input"><span>First name </span>
														<input
															v-model="form.data.clients.purchase[index - 1].profile.name_first"
															type="text"/>
													</label>
													<label><span>Middle name <span
														class="optional">— optional </span></span>
														<input
															v-model="form.data.clients.purchase[index - 1].profile.name_middle"
															type="text">
													</label>
													<label class="input"><span>Last name </span>
														<input
															v-model="form.data.clients.purchase[index - 1].profile.name_last"
															type="text"/>
													</label>
												</div>
												<div
													v-if="form.errors.get('clients.purchase.*.profile', index - 1)"
													class="error-block">
													<p>The client full name is required</p>
												</div>
											</div>
											<label class="input"><span>Email </span>
												<input
													v-model="form.data.clients.purchase[index - 1].email"
													type="text"/>
												<div
													v-if="form.errors.get('clients.purchase.*.email', index - 1)"
													class="error-block">
													<p v-html="form.errors.get('clients.purchase.*.email', index - 1)"/>
												</div>
											</label>
										</div>
									</fieldset>
								</div>
							</div>
						</fieldset>
						<fieldset v-if="numberOfAdditionalRemortgagers" class="fieldset">
							<div>
								<div>
									<legend>
													<span
														class="fieldset__label beta"
														v-html="stringer('Please provide contact details for the ?').nGetText('other owner', '# other owners', numberOfAdditionalRemortgagers).value"/>
									</legend>
								</div>
								<div>
									<fieldset
										v-for="index in numberOfAdditionalRemortgagers" :key="index"
										class="input">
										<legend><span class="beta">{{ $present("ordinal", index + 1) }} Owner</span>
										</legend>
										<div class="input-group">
											<div class="input">
												<div class="input-group input-group--wrap">
													<label class="input"><span>First name </span>
														<input
															v-model="form.data.clients.remortgage[index - 1].profile.name_first"
															type="text"/>
													</label>
													<label><span>Middle name <span
														class="optional">— optional </span></span>
														<input
															v-model="form.data.clients.remortgage[index - 1].profile.name_middle"
															type="text">
													</label>
													<label class="input"><span>Last name </span>
														<input
															v-model="form.data.clients.remortgage[index - 1].profile.name_last"
															type="text"/>
													</label>
												</div>
												<div
													v-if="form.errors.get('clients.remortgage.*.profile', index - 1)"
													class="error-block">
													<p>The client full name is required</p>
												</div>
											</div>
											<label class="input"><span>Email </span>
												<input
													v-model="form.data.clients.remortgage[index - 1].email"
													type="text"/>
												<div
													v-if="form.errors.get('clients.remortgage.*.email', index - 1)"
													class="error-block">
													<p v-html="form.errors.get('clients.remortgage.*.email', index - 1)"/>
												</div>
											</label>
										</div>
									</fieldset>
								</div>
								<div class="actions">
									<ul>
										<li>
											<button
												class="button button--primary"
												@click.prevent="validate('clients', goToNext)">Continue
											</button>
										</li>
									</ul>
								</div>
							</div>
						</fieldset>
						<div class="actions">
							<ul>
								<li>
									<button
										class="button button--primary"
										@click.prevent="validate('data', goToNext)">Continue
									</button>
								</li>
							</ul>
						</div>
					</v-tab>
					<v-tab
						id="summary"
						:tab-key="5"
						label="Summary">
						<template v-if="refs.tabs.isTabSelected('summary')">
							<fieldset class="fieldset">
								<div>
									<div>
										<legend><span class="beta heavy">Service details</span></legend>
									</div>
									<div>
										<dl class="detail-list">
											<div class="detail-list__item">
												<dt>Service</dt>
												<dd v-html="selectedService.names.singular"/>
											</div>
											<div class="detail-list__item">
												<dt>Referrer</dt>
												<dd v-if="!selectedReferrer">—</dd>
												<dd v-else v-html="selectedReferrer.profile.name"/>
											</div>
											<div class="detail-list__item">
												<dt>Assigned Team</dt>
												<dd v-if="!assignedTeam">—</dd>
												<dd v-else v-html="assignedTeam.name"/>
											</div>
											<div class="detail-list__item">
												<dt>Assigned User</dt>
												<dd v-if="!assignedUser">—</dd>
												<dd v-else v-html="assignedUser.profile.name_first"/>
											</div>
										</dl>
									</div>
								</div>
							</fieldset>
							<fieldset class="fieldset">
								<div>
									<div>
										<legend><span class="beta heavy">Client details</span></legend>
									</div>
									<div>
										<dl class="detail-list">
											<div class="detail-list__item">
												<dt>Name</dt>
												<dd
													v-html="$present('fullName', {
												name_first: form.data.client.profile.name.first,
												name_last: form.data.client.profile.name.last,
											})"/>
											</div>
											<div class="detail-list__item">
												<dt>Email</dt>
												<dd v-html="form.data.client.email"/>
											</div>
											<div class="detail-list__item">
												<dt>Phone</dt>
												<dd v-html="form.data.client.profile.phone"/>
											</div>
											<div class="detail-list__item">
												<dt>Correspondence Address</dt>
												<dd>
													<Address :address="form.data.client.profile.address"/>
												</dd>
											</div>
										</dl>
									</div>
								</div>
							</fieldset>
							<fieldset class="fieldset">
								<div>
									<div>
										<legend><span class="beta heavy">Case details</span></legend>
									</div>
									<div class="actions">
										<ul>
											<li>
												<process-button
													:processing="form.processing"
													class="button button--primary"
													text="Create Cases"
													@click.prevent="submit()"/>
											</li>
										</ul>
									</div>
								</div>
							</fieldset>
						</template>
					</v-tab>
				</template>
			</v-tabs>
			<!--			<fieldset>-->
			<!--				<div>-->
			<!--					<div>-->
			<!--						<legend><span>ID Check</span></legend>-->
			<!--					</div>-->
			<!--					<div>-->
			<!--						<label-->
			<!--							class="checkbox"-->
			<!--							:class="{disabled: !$can('idCheck.create') || !$can('idCheck.applyToNewClients')}"><span>Will this client and any related clients need any ID checks? </span>-->
			<!--							<div>-->
			<!--								<input-->
			<!--									type="checkbox" v-model="form.data.client_requirements.id_checks"-->
			<!--									:disabled="!$can('idCheck.create') || !$can('idCheck.applyToNewClients')">-->
			<!--							</div>-->
			<!--							<div-->
			<!--								v-if="!$can('idCheck.create') || !$can('idCheck.applyToNewClients')"-->
			<!--								class="alert-block alert-block&#45;&#45;below">-->
			<!--								<p>This setting is currently disabled.</p>-->
			<!--								<p v-if="!$can('idCheck.create')">Contact Calm to find out more.</p>-->
			<!--								<p v-if="$authed().service_provider.reachedIdCheckLimit">You have reached your ID check credit limit.</p>-->
			<!--							</div>-->
			<!--						</label>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--			</fieldset>-->
			<!--			<fieldset-->
			<!--				v-for="(service, serviceIndex) in selectedServices"-->
			<!--				:key="serviceIndex"-->
			<!--				v-if="service.extra_services.length">-->
			<!--				<div>-->
			<!--					<div>-->
			<!--						<legend><span>{{ $present("ucWords", service.names.singular) }} Details</span></legend>-->
			<!--					</div>-->
			<!--					<div>-->
			<!--						<template v-if="'conveyancing' === service.key">-->
			<!--							<label><span>Transaction Type </span>-->
			<!--								<select-->
			<!--									v-model="form.data.data[service.key].quote_type">-->
			<!--									<option value="" disabled selected>—</option>-->
			<!--									<option value="sale_purchase">Sale & Purchase</option>-->
			<!--									<option value="sale">Sale Only</option>-->
			<!--									<option value="purchase">Purchase Only</option>-->
			<!--									<option value="remortgage">Remortgage</option>-->
			<!--								</select>-->
			<!--							</label>-->
			<!--							<section-->
			<!--								class="fieldset-section">-->
			<!--								<header>-->
			<!--									<h2>Required Conveyancing Packs</h2>-->
			<!--								</header>-->
			<!--								<div-->
			<!--									class="nothing-to-see-here"-->
			<!--									v-if="!form.data.data[service.key].quote_type">-->
			<!--									<p>Select a transaction type to see available conveyancing packs.</p>-->
			<!--								</div>-->
			<!--								<template-->
			<!--									v-if="form.data.data[service.key].quote_type">-->
			<!--									<label-->
			<!--										v-if="showPack(extraService, service)"-->
			<!--										v-for="(extraService, extraServiceIndex) in service.extra_services"-->
			<!--										:key="extraServiceIndex"-->
			<!--										:class="{disabled: !$can(extraService + '.applyToNewClients')}"-->
			<!--										class="checkbox"-->
			<!--									><span v-html="$enum('ExtraServices').display(extraService)"/>-->
			<!--										<input-->
			<!--											type="checkbox"-->
			<!--											v-model="form.data.data[service.id].extra_services[extraService]"-->
			<!--											:disabled="!$can(extraService + '.applyToNewClients')">-->
			<!--										<div class="help-block">-->
			<!--											<p v-if="!$can(extraService + '.applyToNewClients')">This setting is currently disabled.</p>-->
			<!--										</div>-->
			<!--									</label>-->
			<!--								</template>-->
			<!--							</section>-->
			<!--						</template>-->
			<!--					</div>-->
			<!--				</div>-->
			<!--			</fieldset>-->
		</div>
	</form>
</template>
<script>
import conveyancingFormFields from "@/constants/conveyancingFormFields";
import {mapActions} from "vuex";
import Address from "../../../../../components/Address.vue";
import ConveyancingFieldsets from "../../../../../components/forms/ConveyancingFieldsets.vue";
import AddressLookup from "../../../../../components/forms/fields/AddressLookup.vue";
import hasFormFields from "../../../../../mixins/hasFormFields";

export default {
	components: {
		Address,
		ConveyancingFieldsets,
		AddressLookup,
	},

	mixins: [
		hasFormFields,
	],

	data() {
		return {
			formReady: false,
			form: this.newForm({
				services: {
					conveyancing: {
						introduce: false,
					},
				},
				service: "",
				referrer: "",
				assign: {
					should_assign: false,
					team: "",
					user: "",
				},
				client: {
					address: {},
					profile: {
						// dob: null,
						name: {
							first: "",
							middle: "",
							last: "",
						},
						phone: null,
					},
					email: null,
					email_confirmation: null,
				},
				data: {
					conveyancing: conveyancingFormFields,
				},
				clients: {
					sale: [{
						profile: {
							name_first: "",
							name_middle: "",
							name_last: "",
						},
						email: "",
					}],
					purchase: [{
						profile: {
							name_first: "",
							name_middle: "",
							name_last: "",
						},
						email: "",
					}],
					remortgage: [{
						profile: {
							name_first: "",
							name_last: "",
						},
						email: "",
					}],
				},
			}),
		};
	},

	computed: {
		selectedService() {
			return _.find(this.form.options.services, ["key", this.form.data.service]) || null;
		},
		validReferrers() {
			if (!this.selectedService) {
				return this.form.options.referrers;
			}

			return _.filter(this.form.options.referrers, referrer => {
				return _.filter(referrer.panels, panel => {
					return panel.service.id = this.selectedService.id;
				}).length;
			});
		},
		selectedReferrer() {
			return _.find(this.form.options.referrers, ["id", this.form.data.referrer]) || null;
		},
		team() {
			if (!this.form.data.assign.team) {
				return null;
			}

			return _.find(this.form.options.teams, team => team.id === this.form.data.assign.team);
		},
		colleagues() {
			if (!this.team) {
				return this.form.options.colleagues;
			}

			return this.team.all_members;
		},
		assignedTeam() {
			return _.find(this.form.options.teams, ["id", this.form.data.assign.team]) || null;
		},
		assignedUser() {
			return _.find(this.form.options.colleagues, ["id", this.form.data.assign.user]) || null;
		},


		additionalClientDetailRequired() {
			return this.numberOfAdditionalSellers > 0 || this.numberOfAdditionalPurchasers > 0 || this.numberOfAdditionalRemortgagers > 0;
		},
		isSale() {
			return this.stringer(this.form.data.data.conveyancing.quote_type).contains("sale");
		},
		isPurchase() {
			return this.stringer(this.form.data.data.conveyancing.quote_type).contains("purchase");
		},
		isRemortgage() {
			return this.stringer(this.form.data.data.conveyancing.quote_type).contains("remortgage");
		},
		numberOfPurchasers() {
			if (!this.isPurchase) {
				return null;
			}
			return parseInt(this.form.data.data.conveyancing.purchase?.number_of_people || 0);
		},
		numberOfAdditionalPurchasers() {
			if (!this.isPurchase) {
				return null;
			}
			return Math.max(this.numberOfPurchasers - 1, 0);
		},
		numberOfSellers() {
			if (!this.isSale) {
				return null;
			}
			return parseInt(this.form.data.data.conveyancing.sale?.number_of_people || 0);
		},
		numberOfAdditionalSellers() {
			if (!this.isSale) {
				return null;
			}
			return Math.max(this.numberOfSellers - 1, 0);
		},
		// additionalSellers() {
		// 	return this.form.data.sale.clients.slice(1);
		// },
		// numberOfSelectedSellers() {
		// 	return _.filter(this.form.data.sale.clients, data => {
		// 		return data.purchaser;
		// 	}).length;
		// },
		numberOfRemortgagers() {
			if (!this.isRemortgage) {
				return null;
			}
			return parseInt(this.form.data.data.conveyancing.remortgage?.number_of_people || 0);
		},
		numberOfAdditionalRemortgagers() {
			if (!this.isRemortgage) {
				return null;
			}
			return Math.max(this.numberOfRemortgagers - 1, 0);
		},
	},

	methods: {
		...mapActions("clients", [
			"addModel",
		]),
		selectService() {
			let data = _.mapValues(this.form.getData("services"), (value, service) => {
				value.introduce = (service === this.form.data.service);
				return value;
			});
			this.form.set("services", data);
		},
		validate(section, callback) {
			this.form.validate(section).post(this.route("clients")).then(() => {
				callback();
			});
		},
		showPack(extraService, service) {
			let conditions = {
				proofOfFunds: ["sale_purchase", "purchase"],
				protocolPack: ["sale_purchase", "sale"],
				searchPack: ["sale_purchase", "purchase"],
				searchPolicy: ["remortgage"],
			};

			return !_.has(conditions, extraService) || conditions[extraService].indexOf(this.form.data.data[service.key].quote_type) > -1;
		},
		newClientNumber(newClientIndex) {
			return parseInt(newClientIndex) + 1;
		},
		setAdditionalClientFields() {
			this.form.setInstances("clients.sale", this.numberOfAdditionalSellers);
			this.form.setInstances("clients.purchase", this.numberOfAdditionalPurchasers);
			this.form.setInstances("clients.remortgage", this.numberOfAdditionalRemortgagers);
			// this.form.set("data.conveyancing.sale.clients", this.form.data.client, 0);
			// this.form.set("data.conveyancing.purchase.clients", this.form.data.client, 0);
			// this.form.set("data.conveyancing.remortgage.clients", this.form.data.client, 0);
		},
		async submit() {
			if (!this.form.data.related_clients) {
				this.form.set("new_clients", []);
			}
			this.form.post("clients").then(response => {
				this.addModel(response.data);
				this.$router.push({name: "clients.show", params: {client: response.data.id}});
				this.$store.dispatch("alertsStore/success", "Client Created");
			});
		},
	},

	created() {
		this.form.prepare();
		http().get(this.route("form-data/client", this.serviceProvider)).then(response => {
			this.form.setOptions(response.data);
			this.form.ready();
		});
	},
};
</script>
